// ============================================================
// HUBSPOT FORMS API UTILITY
// Submits form data to backend, which pushes to HubSpot CRM
// ============================================================

const API = process.env.REACT_APP_BACKEND_URL;

function getUTMParams() {
  if (typeof window === 'undefined') return {};
  const params = new URLSearchParams(window.location.search);
  const utm = {};
  ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content'].forEach((k) => {
    const v = params.get(k);
    if (v) utm[k] = v;
  });
  return utm;
}

function getPageContext() {
  if (typeof window === 'undefined') return {};
  return {
    page_url: window.location.href,
    page_path: window.location.pathname,
  };
}

async function post(endpoint, data) {
  try {
    const res = await fetch(`${API}${endpoint}`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        ...data,
        ...getUTMParams(),
        ...getPageContext(),
      }),
    });
    if (res.ok) {
      const json = await res.json();
      return { success: true, data: json };
    }
    return { success: false, error: 'Server error' };
  } catch (e) {
    return { success: false, error: e.message };
  }
}

export async function submitContactForm(form) {
  return post('/api/contact', {
    full_name: `${form.firstName} ${form.lastName}`.trim(),
    email: form.email,
    company: form.company,
    phone: form.phone || '',
    project_type: form.projectType || '',
    how_can_we_help: form.message || '',
  });
}

export async function submitAssessmentForm(form) {
  return post('/api/assessment', {
    first_name: form.firstName,
    last_name: form.lastName,
    email: form.email,
    company: form.company,
    phone: form.phone || '',
    challenge_area: form.challengeArea || '',
    company_size: form.companySize || '',
    timeline: form.timeline || '',
    details: form.details || '',
  });
}

export async function submitStrategyCallForm(form) {
  return post('/api/contact', {
    full_name: `${form.firstName} ${form.lastName}`.trim(),
    email: form.email,
    company: form.company,
    phone: form.phone || '',
    how_can_we_help: 'Strategy Call Request',
    source: 'strategy_call',
  });
}

export async function submitNewsletterForm({ email }) {
  return post('/api/newsletter/subscribe', { email });
}

export async function submitGatedContentForm(form) {
  return post('/api/gated-content/download', {
    email: form.email,
    first_name: form.firstName,
    last_name: form.lastName || '',
    company: form.company || '',
    content_id: form.contentId || form.contentTitle?.toLowerCase().replace(/\s+/g, '-') || 'unknown',
    content_title: form.contentTitle || '',
  });
}
